
declare var dataLayer: any;
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    Footer: () => import("@/components/Jobs/Homepage/Footer.vue"),
  },
})
export default class Terms extends Vue {
  async mounted() {}
}
